export default __webpack_public_path__ + "a98a0e63cc9fef78f7d72d65784d9628.jpg";